import React from 'react';
import { Text } from '@chakra-ui/react';
import { ConfirmDialog } from 'src/components/molecules/ConfirmDialog';

type DeleteModelDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  modelName: string;
  isLoading: boolean;
  /** Long-term models built on this model — deleted together with it. */
  dependentModelNames?: string[];
};

export const DeleteModelDialog: React.FC<DeleteModelDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  modelName,
  isLoading,
  dependentModelNames = [],
}) => {
  return (
    <ConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      headerText="Delete Model"
      bodyText={
        <>
          <Text>
            Are you sure you want to delete <strong>{modelName}</strong>? All
            forecasts and goals you have created on it will be deleted. This
            action cannot be undone.
          </Text>
          {dependentModelNames.length > 0 && (
            <Text mt={3}>
              The long-term model
              {dependentModelNames.length > 1 ? 's' : ''}{' '}
              <strong>{dependentModelNames.join(', ')}</strong>{' '}
              {dependentModelNames.length > 1 ? 'are' : 'is'} built on this
              model and will be deleted as well.
            </Text>
          )}
        </>
      }
      confirmText="Delete"
      isLoading={isLoading}
    />
  );
};
